<template>

    <div class="vendor-agata-location-list">
        <div class="order-header mb-20">
            <i class="ion-location"></i>
            <h2>Wybierz salon Agata Meble</h2>
        </div>
        <div class="order-vendor-information">
            <div class="option-container main-option-container">
                <div class="option4" v-bind:class="{ 'option-active': loc.ID == locationId }" v-for="(loc,i) in locations" v-on:click="setWarehouse(loc)" :key="i"><p :class="[loc.cssClass]"  v-html="loc.City"></p></div>
            </div>
        </div>

        <div class="order-info-block" v-show="warehouseError === true">
            <p class="error-message">Prosimy o wybór salonu z dostępnej listy.</p>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'vendorAgataLocationList',
        props: ['warehouseError'],
        data () {
            return {
                vendorId: 2,
                locationId: null,
                location: null,
                locations: []
            }
        },
        methods: {
            setWarehouse: function (loc) {
                console.log('LOCATION:');
                console.log(loc);
                this.location = loc;
                this.locationId = loc.ID;
                this.$store.commit('setDivisionName', loc.SalesName)
                this.$store.commit('setDivisionExternalSymbol', loc.SymbolExternal)
                this.$store.commit('setPokId', loc.ID)
                this.$emit("setVendorWarehouse", loc);
            }
        },
        mounted: function () {

            var self = this;
            this.$http.get("/api/vendor/warehousesList/" + this.vendorId).then(function (response) {
                self.locations = response.data.warehouses;
            });
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// VendorAgataLocationList.vue?0e68f586